import { fetchApi } from '@/common-utilities/fetch-utilities';
import { API_ENDPOINTS } from '@/common-constants/api-constants';
import type { AuditLogsResponse, AuditLogsQueryParams } from '@/common-types';

/**
 * Get audit logs with pagination
 */
export async function getAuditLogs(params?: AuditLogsQueryParams): Promise<AuditLogsResponse> {
  const queryParams = new URLSearchParams();
  
  if (params?.limit) {
    queryParams.set('limit', params.limit.toString());
  }
  
  if (params?.startKey) {
    queryParams.set('startKey', params.startKey);
  }
  
  const endpoint = `${API_ENDPOINTS.AUDIT}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  const response = await fetchApi<AuditLogsResponse>(endpoint);
  return response.data;
}

export default {
  getAuditLogs,
};




